import React from 'react';
import { useTranslate } from '@/translations';
import { PageContainer, Title, faUserPlus } from '@/ui/components';

import { Card } from 'antd';
import { ManageUsersDataGrid } from './components/ManageUsersDataGrid';

export const ManageUsers = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('manageUsers')} icon={faUserPlus} />
      <Card>
        <ManageUsersDataGrid />
      </Card>
    </PageContainer>
  );
};
